var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isAuthenticated)?_c('div',{staticClass:"app-layout"},[_c('Sidebar'),_c('div',{staticClass:"main-section"},[_c('PageHeader'),_c('router-view',{staticClass:"page-content"})],1)],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }